'use client'

import { useRouter, useSearchParams } from 'next/navigation'
import { createContext, useContext, useEffect, useState } from 'react'

type CareShareTabsContextValue = {
  activeTab: string
  handleTabChange: (value: string) => void
}

const CareShareTabsContext = createContext<CareShareTabsContextValue | null>(
  null
)

export const CareShareTabsProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const category = searchParams.get('category')

  const [activeTab, setActiveTab] = useState<string>(
    category || 'care-and-share'
  )

  const handleTabChange = (value: string) => {
    // Update UI immediately, không đợi router.replace (RSC round-trip) mới đổi tab
    setActiveTab(value)
    router.replace(`?category=${value}`, { scroll: false })
  }

  useEffect(() => {
    if (category && category !== activeTab) {
      setActiveTab(category)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category])

  return (
    <CareShareTabsContext.Provider value={{ activeTab, handleTabChange }}>
      {children}
    </CareShareTabsContext.Provider>
  )
}

export const useCareShareTabsContext = () => {
  const ctx = useContext(CareShareTabsContext)
  if (!ctx) {
    throw new Error(
      'useCareShareTabsContext must be used within CareShareTabsProvider'
    )
  }
  return ctx
}
